export default __webpack_public_path__ + "static/Musk-e185c68da523af246f569861444e5796.png";